import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';

export class AffinityEarthTrait extends Trait {
  static baseType = TraitType.AffinityEarth;
  static baseTitle = 'Elemental Affinity (Earth)';
  static baseText = 'Immune to Brittle and Clumsy.';
  static baseIcon = 'trait';

  type = AffinityEarthTrait.baseType;
  title = AffinityEarthTrait.baseTitle;
  text = AffinityEarthTrait.baseText;
  icon = AffinityEarthTrait.baseIcon;

  modifierAdd(type: StatusEffect, stacks: number) {
    if (type == StatusEffect.Brittle || type == StatusEffect.Clumsy) {
      return 0;
    }
    return stacks;
  }
}

TraitRegistry.register(AffinityEarthTrait.baseType, AffinityEarthTrait);
